"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnCallDutyUpdatedMessage = void 0;
const workerMessage_1 = require("./workerMessage");
const model_1 = require("../model");
class OnCallDutyUpdatedMessage extends workerMessage_1.WorkerMessage {
    constructor(onCallDutyId, onCallDuty, originalOnCallDuty) {
        super(model_1.QueueDefinitions.ON_CALL_DUTY_UPDATED);
        this.onCallDutyId = onCallDutyId;
        this.onCallDuty = onCallDuty;
        this.originalOnCallDuty = originalOnCallDuty;
    }
}
exports.OnCallDutyUpdatedMessage = OnCallDutyUpdatedMessage;
